
const cabinetTeamType = {
  CABINET_TEAM_TABLE_STATE_SET: 'CABINET_TEAM/TABLE_STATE_SET',
  CABINET_TEAM_TABLE_STATE_RESET: 'CABINET_TEAM/TABLE_STATE_RESET',
};
export default cabinetTeamType;
